/* eslint-disable indent */
import { VehiculeCheckProgressStatus } from '@/api/entities/vehicule-check';
import { ProgressIndicator } from '@/components/ProgressIndication';
import { TFunction } from 'i18next';

type VehiculeCheckProgressIndicatorProps = {
  t: TFunction<undefined>;
  progress: number;
  vehiculeCheckProgressStatus: VehiculeCheckProgressStatus;
};

export const VehiculeCheckProgressIndicator = ({
  t,
  progress,
  vehiculeCheckProgressStatus,
}: VehiculeCheckProgressIndicatorProps) => {
  return (
    <ProgressIndicator
      text={
        <div className="flex items-center justify-center gap-4.5">
          {(progress === 0 ||
            vehiculeCheckProgressStatus ===
              VehiculeCheckProgressStatus.COMPLETED_STILL_PROCESSING_VIDEO) && (
            <i className="ki-filled ki-abstract-48 text-purple-A713F6 text-[20px] animate-ping" />
          )}
          <div className="text-purple-A713F6 text-md font-medium">
            {`${
              vehiculeCheckProgressStatus ===
                VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_VIDEO ||
              VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_CHUNKS
                ? progress === 0
                  ? t('loadingVideo')
                  : // : progress >= 99
                  vehiculeCheckProgressStatus ===
                    VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_CHUNKS
                  ? t('combiningVideoChunksInProgress')
                  : t('videoUploadInProgress')
                : t('resultProcessingByAIInProgress')
            }...`}
          </div>
        </div>
      }
      showProgress={
        progress !== 0 &&
        vehiculeCheckProgressStatus !==
          VehiculeCheckProgressStatus.COMPLETED_STILL_PROCESSING_VIDEO
      }
      progress={progress}
    />
  );
};
